/* magnifique-form.js — RSVP form handler */
(function () {

  var form    = document.getElementById('mgq-rsvp-form');
  var btn     = document.getElementById('mgq-rsvp-btn');
  var success = document.getElementById('mgq-rsvp-success');
  var errEl   = document.getElementById('mgq-rsvp-error');

  /* Worker URL set from Shopify customizer via window.MGQ_WORKER_URL */
  var WORKER_URL = window.MGQ_WORKER_URL || 'https://YOUR_WORKER.YOUR_SUBDOMAIN.workers.dev/rsvp';

  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearError();

    var data = {
      email:      val('mgq-f-email'),
      name:       val('mgq-f-name'),
      phone:      val('mgq-f-phone'),
      zip:        val('mgq-f-zip'),
      instagram:  val('mgq-f-instagram'),
      heard:      getHeard(),
      plus_one:   getPlusOne(),
      submitted:  new Date().toISOString()
    };

    if (!data.email || !data.name || !data.phone || !data.heard || !data.plus_one) {
      showError('Please fill in all required fields.');
      return;
    }

    setLoading(true);

    fetch(WORKER_URL, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(data)
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Server error ' + res.status);
      return res.json();
    })
    .then(function () {
      setLoading(false);
      form.style.display = 'none';
      if (success) success.classList.add('mgq-rsvp-success--visible');
      /* fire unlock after short delay — only if post-submit is enabled */
      setTimeout(function () {
        if (window.MGQ_ENABLE_POST_SUBMIT === false) return;
        if (typeof unlockExperience === 'function') unlockExperience();
        else document.dispatchEvent(new CustomEvent('mgq:rsvp-complete'));
      }, 1800);
    })
    .catch(function (err) {
      setLoading(false);
      showError('Something went wrong. Please try again.');
      console.error('RSVP error:', err);
    });
  });

  function val(id) {
    var el = document.getElementById(id);
    return el ? el.value.trim() : '';
  }
  function getHeard() {
    var checked = form.querySelector('input[name="heard"]:checked');
    if (!checked) return '';
    if (checked.value === 'other') {
      var other = document.getElementById('mgq-f-heard-other');
      return other ? other.value.trim() : 'Other';
    }
    return checked.value;
  }
  function getPlusOne() {
    var checked = form.querySelector('input[name="plus_one"]:checked');
    if (!checked) return '';
    if (checked.value === 'other') {
      var other = document.getElementById('mgq-f-plusone-other');
      return other ? other.value.trim() : 'Other';
    }
    return checked.value;
  }
  function setLoading(on) {
    if (!btn) return;
    btn.disabled = on;
    btn.querySelector('span').textContent = on ? 'Sending…' : 'Confirm Your Place';
  }
  function showError(msg) {
    if (errEl) { errEl.textContent = msg; errEl.style.display = 'block'; }
  }
  function clearError() {
    if (errEl) { errEl.textContent = ''; errEl.style.display = 'none'; }
  }

  /* listen for unlock trigger from outside */
  /* mgq:rsvp-complete is caught by magnifique.js which respects ENABLE_POST_SUBMIT */

})();